export const selectTaskDetails = (state) => state.taskDetails;
